import React from "react";
import t from "../../../helpers/t";
import { _ } from "../../../../../vendor";

const SubChanges = (props) => {
  let setted = "";
  return (
    <>
      {props.subChanges.map((text) => {
        return (
          <>
            <p>{text}</p>
          </>
        );
      })}
    </>
  );
};

export default SubChanges;
